import angular from 'angular';
import autofocus from './autofocus.directive';
import noFutureDates from './noFutureDates.directive';
import passwordMatch from './passwordMatch.directive';

/**
 *  Module definition for directives
 */
const directives = angular.module('app.directives', []);

directives.directive('exAutofocus', autofocus);
directives.directive('noFutureDates', noFutureDates);
directives.directive('passwordMatch', passwordMatch);

export default directives.name;


// WEBPACK FOOTER //
// ./src/app/misc/directives/directives.js